import { uniq } from 'lodash';
import { writeBrowserStorage } from '../resources/writeBrowserStorage';

export { default as oscarDatabase } from 'fantasyoscars-functions/src/oscarDatabases/2026.json';

// TODO: figure this out
// export { thisOscarsYear } from 'fantasyoscars-functions/src/';
export let thisOscarsYear = 2026

export let TRANSITION_DURATION = 200;

export let DEV = process.env.NODE_ENV === 'development';
export let VERSION_HASH = process.env.NEXT_PUBLIC_COMMIT_HASH;

export let LINK_TYPES = {
  invitation: {
    key: 'invitation',
    handle: async ({ link: { leagueId } }: { link: { leagueId: string } }) => {
      await writeBrowserStorage(last => ({
        ...last,
        leaguesToJoinIds: uniq([...(last?.leaguesToJoinIds || []), leagueId]),
      }));
    },
  },
  promotionLinkStarWars2023: {
    key: 'promotionLinkStarWars2023',
    handle: async () => {
      await writeBrowserStorage(last => ({
        ...last,
        promotionLinkStarWars2023: true,
      }));
    },
  },
} as const;

export let languageOptions = {
  english: {
    key: 'english',
    locale: 'en-US',
    getLabel: (copy: {
      languageName: {
        english: string;
      };
    }): string => copy.languageName.english,
  },
  spanish: {
    key: 'spanish',
    locale: 'es',
    getLabel: (copy: {
      languageName: {
        spanish: string;
      };
    }): string => copy.languageName.spanish,
  },
} as const;

export const supportEmail = 'fantasyoscars@gmail.com';

export let LEAGUE_NAME_MAX_LENGTH = 100;

export let SITE_URL = 'https://fantasyoscars.siteless.co';
export let SITE_NAME = 'Fantasy Oscars';
export let SITE_DESCRIPTION = `Predict the ${thisOscarsYear} Oscars winners with friends. Create a league, fill out your ballot, and track scores live. Free to play — no download needed.`;

export let tmdbConfig = {
  base_url: 'https://image.tmdb.org/t/p/',
  backdrop_sizes: {
    w300: 'w300',
    w780: 'w780',
    w1280: 'w1280',
    original: 'original',
  },

  logo_sizes: {
    w45: 'w45',
    w92: 'w92',
    w154: 'w154',
    w185: 'w185',
    w300: 'w300',
    w500: 'w500',
    original: 'original',
  },

  poster_sizes: {
    w92: 'w92',
    w154: 'w154',
    w185: 'w185',
    w342: 'w342',
    w500: 'w500',
    w780: 'w780',
    original: 'original',
  },

  profile_sizes: {
    w45: 'w45',
    w185: 'w185',
    h632: 'h632',
    original: 'original',
  },

  still_sizes: {
    w92: 'w92',
    w185: 'w185',
    w300: 'w300',
    original: 'original',
  },
} as const;

export let moviePosterAspectRatio = 278 / 185;

export let tmdbApiKey = '535839fc859c282a3fc5ea2eac56c34f';


export let buyMeACoffeeUrl = 'https://www.buymeacoffee.com/fantasyoscars';

// Sticky menu floating action button layout
// Distance from the screen edge (right or left depending on hand mode)
export let STICKY_BUTTON_INSET = 22;
// Diameter of the circular button
export let STICKY_BUTTON_SIZE = 90;
// Center point from the screen edge: inset + size / 2
export let STICKY_BUTTON_CENTER = STICKY_BUTTON_INSET + STICKY_BUTTON_SIZE / 2;

export let zIndex = {
  base: 0,
  banner: 2,
  stickyMenuBackdrop: 3,
  stickyMenu: 4,
  modal: 5,
  alert: 9,
  splashLoader: 10,
} as const;
